import React from 'react';
import { Link } from 'react-router-dom';
import publicationimg from '../../images/publications2.jpg';
import updatesimg from '../../images/updates2.jpg';
import './Universe.css';
import '../../App.css';

const Universe = () => {
  return (
    <>
      <div id="universe" className="universe" style={{ paddingTop: '1rem', marginBottom: '6rem' }}>
        <div className='reveal'>
          <h1>Updates</h1>
          <p>&nbsp;</p>
        </div>
        <div className="blocks reveal" >
          <Link to="/updates" target='_blank' >
            <img src={updatesimg} alt='updates_img' className='banner_img'></img>
          </Link>
          <Link to="/publications" target='_blank'>
            <img src={publicationimg} alt='publication_img' className='banner_img'></img>
          </Link>
        </div>
      </div>
      {/* <hr style={{width:'75%', margin:'auto', height:'1.5px', background: '#817d7d'}}/> */}
    </>
  );
}

export default Universe;
